import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';

export default function LineChart({linechartData, xMax, yMax}){
  const chartRef = useRef(null);
  //const [linechartData, setLineChartData] = useState({});
  
  useEffect(() => {
    const data = {
      //labels: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
      labels: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      datasets: [
        {
          label: 'Error Count',
          //data: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60,1000],
          data: linechartData,
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
        },
      ],
    };

    const options = {
      scales: {
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: ['Time']
          },
          ticks: {
            beginAtZero: true,
            max: xMax // Set max visible data
          }
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Number of alert limit exceeded'
          },
          ticks: {
            max: yMax, // Set max visible data
            autoSkip: false,
            stepSize: (yMax/10),
          }
        }],
        responsive: true,
        width:  1200,
        height: 980,
      },
    };
    
    const linechart = new Chart(chartRef.current, {
      type: 'bar',
      data: data,
      options: options,
    });

    //setLineChartData(linechart);
  }, [linechartData,xMax,yMax]);

  return (
    <canvas ref={chartRef} width={'1200'} height={'980'}></canvas>
  );
};